export interface NetLogConfig {
  requests: boolean;
  responses: boolean;
  errors: boolean;
  headers: boolean;
  requestBody: boolean;
  responseBody: boolean;
  errorBody: boolean;
  timing: boolean;
  maxBodyLength: number;
  maxFieldLength: number;
  ignoredUrls: RegExp[];
}

export const netLogConfig: NetLogConfig = {
  requests: true,
  responses: true,
  errors: true,
  headers: false,
  requestBody: false,
  responseBody: false,
  errorBody: true,
  timing: true,
  maxBodyLength: 2000,
  maxFieldLength: 512,
  ignoredUrls: [],
};

export function isLoggedUrl(url: string | undefined): boolean {
  return !netLogConfig.ignoredUrls.some((ignored) => ignored.test(url ?? ""));
}
